import { DOCUMENT } from "@angular/common";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { firstValueFrom, Observable, Subscription, switchMap, take } from "rxjs";
import { CustomerDTO } from "../../../shared/models/Customers/CustomerDTO";
import { EstatusJSON } from "../../../shared/models/EstatusJSON";
import { MediaMatcher } from "@angular/cdk/layout";
import { Router } from "@angular/router";
import { EnumLocationCategories } from "../../../shared/helpers/enums/EnumLocationCategories";
import { MapHelperService } from "src/services/map-helper.service";
import { LayerDTO } from "../../models/LayerDTO";
import { LocationCategoryDTO } from "../../models/LocationCategoryDTO";
import { LocationDTO } from "../../models/LocationDTO";
import { PanelLocationsService } from "../../services/Panel-Locations.service";
import { FilterMapService } from "../../services/Filter-Map.service";
import { MatDialog } from "@angular/material/dialog";
import { TutorialService } from "src/app/features/shared/features/tutorial/services/tutorial.service";
import { SignalUser } from "src/app/features/shared/models/SignalUser/SignalUser";
import { NotificationsToastService } from "src/app/features/shared/services/Notifications-Toast.service";
import { SignalUserService } from "src/app/features/shared/services/ServiceCatalogEncapsulators/Signal-User.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { SignalRService } from "src/app/features/shared/services/Signal-R.service";
import { PanelInternalLayerService } from "../../services/Panel-Internal-Layer.service";
import { StatusFlag } from "../../models/StatusFlag";
import { EnumAlarmCategoriesColors, EnumAlarmCategoriesValues, EnumAlarmCategory } from "src/app/features/shared/helpers/enums/EnumAlarmCategories";
@Component({
  selector: "panel-locations",
  templateUrl: "./panel-locations.component.html",
  styleUrls: ["./panel-locations.component.css"],
})
export class PanelLocationsComponent implements OnInit, OnDestroy {

  dummyStatusFlags: StatusFlag[] = [
    { flagName: "En Movimiento", priorityHex: "#4CAF50" },
    { flagName: "Batería Baja", priorityHex: "#FFC107" },
    { flagName: "Desconectado", priorityHex: "#F44336" },
  ];

  dummyFlagTypes: number[] = [1, 4, 6];

  
  @Output() onCardClickedEmitter: EventEmitter<any>;
  @Output() onCardFilterEmitter: EventEmitter<any>;

  //variables para los tab de la lista de locaciones
  @Input() $ItemsGet: LocationDTO[];
  @Input() $Items: LocationDTO[];
  itemsGetFilterRespaldo: LocationDTO[];
  itemsFilterRespaldo: LocationDTO[];
  $itemsFilterGlobal: { location: LocationDTO; tipo: string }[] = [];
  vinsFilterGlobal: LocationDTO[] = [];
  isLocationListEnd: boolean = false;
  isVisibleGPSTabs : boolean = true;
  totalActualizados: string = "";
  totalDesactualizados: string = "";
  totalSinReporte: string = "";

  public isMapix: boolean = false;
  public isLoading: boolean = false;
  signalUser: SignalUser;
  fullScreen: boolean = false;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  //variables de buscador
  globalFinder: string = "";
  signalIdentifier: string = "";

  //variables de filtro
  moduleSearch: string = "LocationSearch";
  filters: any[] = [];
  filtersSelected: any[] = [];
  filtersObject: { filters: any[], selected: any[] } = { filters: [], selected: [] };
  ApplyFilter: boolean = false;
  isGlobalFilterActive: boolean = false;
  
  //variables de estado (que se encuentra seleccionado)
  selectedTabIndex: number = 1;
  excelDownloadOperation: string = "";
  selectedCategoryItem : LocationCategoryDTO;

  //variables de filtro de disponibilidad (de momento se dejaron de usar)
  // AvailabilityFiltersObject: { filters, selected, startDate, endDate, idLocationCategories };
  // availabilityFiltersSelected: any[] = [];
  // availabilityCateoriesSelected: number[] = [];
  // ApplyAvailabilityFilter: boolean = false;
  // availabilityInitialDate: Date = null;
  // availabilityFinalDate: Date = null;
  // availabilityFilter : boolean = false;

  suscription_postLocationsToExcel: Subscription;
  Subscription_AfterClosed: Subscription;
  subscription_GetFilters: Subscription;
  subscription_GetLoading: Subscription;
  subscription_GetList: Subscription;
  subscription_GetFiltroBase: Subscription;
  subscription_GetValuesFilters: Subscription;
  subscription_GetListFiltered: Subscription;
  subscription_findUpdatedByIdentifier: Subscription;
  subscription_GetCategoryList: Subscription;
  subscription_GetAllLocationsFilteredList: Subscription;
  subscription_GetSearch: Subscription;
  subscription_GetTotalActualizado: Subscription;
  subscription_GetTotalDesactualizado: Subscription;
  subscription_GetTotalSinReporte: Subscription;
  private subscriptionsFilter: Subscription[] = [];
  categories : {category: LocationCategoryDTO, total:number, isVisible: boolean}[] = [];

  constructor(
    private panelLocationsService: PanelLocationsService,
    private router: Router,
    private sessionService: SessionService,
    private signalRService: SignalRService,
    private signalUserService: SignalUserService,
    private notificationsToastService: NotificationsToastService,
    public dialog: MatDialog,
    private filterMapService: FilterMapService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private mapHelperService: MapHelperService,
    private panelInternalLayerService: PanelInternalLayerService,
    private tutorialService: TutorialService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.onCardClickedEmitter = new EventEmitter<any>();
    this.onCardFilterEmitter = new EventEmitter<any[]>();
    this.signalUser = new SignalUser();
    this.getLocations();
    this.getFilters();

    this.subscription_GetLoading = this.panelLocationsService
      .getLoading()
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.subscription_GetSearch = this.panelLocationsService
      .getSearchData() .subscribe((data: string) => {
        this.globalFinder = data;

        if (this.globalFinder.length > 1)
          this.onGlobalFilter(this.globalFinder);
      });
    this.panelLocationsService.setLoading(true);
    // this.panelLocationsService.setVisibilityPanel(true);

  }

  ngOnInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.checkingURL();
    this.GetCategories();
    if (this.isVisibleGPSTabs) {
      this.GetGPSTotals();
    }
  }

  ngOnDestroy() {
    if (this.subscription_GetFilters)
      this.subscription_GetFilters.unsubscribe();
    if (this.subscription_GetList) this.subscription_GetList.unsubscribe();
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_GetFiltroBase)
      this.subscription_GetFiltroBase.unsubscribe();
    if (this.subscription_GetListFiltered)
      this.subscription_GetListFiltered.unsubscribe();
    if (this.subscription_GetValuesFilters)
      this.subscription_GetValuesFilters.unsubscribe();
    if (this.subscription_findUpdatedByIdentifier)
      this.subscription_findUpdatedByIdentifier.unsubscribe();
    if (this.subscription_GetCategoryList)
      this.subscription_GetCategoryList.unsubscribe();
    if (this.subscription_GetAllLocationsFilteredList)
      this.subscription_GetAllLocationsFilteredList.unsubscribe();
    if (this.subscription_GetSearch)
      this.subscription_GetSearch.unsubscribe();
    if (this.subscription_GetTotalActualizado)
      this.subscription_GetTotalActualizado.unsubscribe();
    if (this.subscription_GetTotalDesactualizado)
      this.subscription_GetTotalDesactualizado.unsubscribe();
    if (this.subscription_GetTotalSinReporte)
      this.subscription_GetTotalSinReporte.unsubscribe();


    this.subscriptionsFilter.forEach((subscription) =>
      subscription.unsubscribe()
    );
  }

  selectTab(event: any) {
    this.selectedTabIndex = event.tab.textLabel;
    console.log("tab selected", event, event.tab.textLabel, this.categories);
    this.$Items = [];
    this.$ItemsGet = [];
    this.isLocationListEnd = false;
    this.unsubscribeTabs();
    this.unsubscribeFocusPin();
    this.getLocations();
  }

  unsubscribeTabs(){
    if (this.subscription_findUpdatedByIdentifier)
      this.subscription_findUpdatedByIdentifier.unsubscribe();
    if (this.subscription_GetList)
      this.subscription_GetList.unsubscribe();
    if (this.subscription_GetListFiltered)
      this.subscription_GetListFiltered.unsubscribe();
  }

  unsubscribeGlobalFilter(){
    if (this.subscription_GetAllLocationsFilteredList)
      this.subscription_GetAllLocationsFilteredList.unsubscribe();
  }

  unsubscribeFocusPin(){
    if (this.signalIdentifier.length > 0){
      this.mapHelperService.stopFocusPin();
      this.UnsubscribeSignalUser(this.signalUser);
    }
  }

  getLocations(page: number = 1) {
    this.panelLocationsService.setLoading(true);
    if (this.selectedTabIndex == 1) {
      this.excelDownloadOperation = "Actualizado";
      this.getLocationsActualizados(page);
    } else if (this.selectedTabIndex == 2) {
      this.excelDownloadOperation = "Desactualizado";
      this.getLocationsDesactualizados(page);
    } else if (this.selectedTabIndex == 3){
      this.excelDownloadOperation = "S/R";
      this.getLocationsSinReporte(page);
    } else{
      //se restan 4 porque en el label de las categorias se sumó a al label un 4 arbitrario. el objetivo de esta suma es que haya una convivencia entre tabs de categorias y de gps
      //los primeros 3 tabs son de funciones de gps y no llaman categoroias, el resto de tabs son de categorias y debe usarse su id
      this.selectedCategoryItem = this.categories[this.selectedTabIndex -4].category;
      console.log("selected category", this.selectedCategoryItem, this.selectedTabIndex);
      this.panelLocationsService.setLoading(true);
      // this.excelDownloadOperation = this.selectedCategoryItem.id + 3;
      this.excelDownloadOperation = "Category";
      this.getLocationsByCategory(this.selectedCategoryItem, page);
    }
  }

  getLocationsActualizados(page: number) {
    if (this.filtersSelected.length < 1) {
      this.subscription_GetList = this.panelLocationsService
          .GetListActualizadosPage(page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {
                this.totalActualizados = data.result.contador.toString();
                this.setLocationList(data, page);
                console.log("Actualizados", this.$Items);
              }
              this.ApplyFilter = false;
            },
            (error) => {
              // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
    } else {
      this.getFilterTab("Actualizado", this.globalFinder);
    }
  }

  getLocationsDesactualizados(page: number) {
    if (this.filtersSelected.length < 1) {
      this.subscription_GetList = this.panelLocationsService
          .GetListDesactualizadosPage(page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {
                this.totalDesactualizados = data.result.contador.toString();
                this.setLocationList(data, page);
                console.log("Desactualizados", data, this.$Items);

              }
              this.ApplyFilter = false;
            },
            (error) => {
              //Error callback
              // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
    } else {
      this.getFilterTab("Desactualizado", this.globalFinder);
    }
    //this.locations.GetLocations();
  }

  getLocationsSinReporte(page: number) {
    if (this.filtersSelected.length < 1) {
      this.subscription_GetList = this.panelLocationsService
          .GetListSinReportePage(page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {

                this.totalSinReporte = data.result.contador.toString();
                this.setLocationList(data, page);
                console.log("S/R", this.$Items);
              }
              this.ApplyFilter = false;
            },
            (error) => {
              //Error callback
              // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
        //this.locations.GetLocations();
    } else {
      this.getFilterTab("S/R", this.globalFinder);
    }
  }

  // --------------- tabs de categories --------------

  getLocationsByCategory(category: LocationCategoryDTO, page: number) {
    console.log("get by idcategory", category);
    //&& !this.ApplyAvailabilityFilter
    if (!this.ApplyFilter ) {
      this.SetSystemLayersOn(this.selectedCategoryItem);
        this.subscription_GetList = this.panelLocationsService
          .GetListByIdLocationCategoryPage(category.id, page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {
                this.categories.find( cat =>cat.category.id == category.id ).total = data.result.contador;
                this.setLocationList(data, page);
                console.log("get by idcategory response", this.$Items, data.result);
              }
              this.ApplyFilter = false;
            },
            (error) => {
              // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
    } else {
      if (this.ApplyFilter) {
        this.SetSystemLayersOn(this.selectedCategoryItem);
        this.subscription_GetListFiltered = this.panelLocationsService
        .getListFilterTab( this.filtersSelected, "Category", "", category.id )
        .subscribe(
          (data: EstatusJSON) => {
            console.log("filtro actualizado", data.result);
            this.$Items = data.result;
            this.$ItemsGet = this.$Items;
            this.ApplyFilter = true;
            this.panelLocationsService.setLoading(false);
          },
          (error) => {
            //Error callback
            // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
            this.panelLocationsService.setLoading(false);
            return false;
          }
        );
      }else{
        // this.subscription_GetListFiltered = this.panelLocationsService
        //   .GetListAvailabilityFilterByLocationCategory(
        //     this.availabilityFiltersSelected,
        //     this.availabilityInitialDate.toISOString(),
        //     this.availabilityFinalDate.toISOString(),
        //     [this.selectedCategoryItem.id]
        //   )
        //   .subscribe(
        //     (data: EstatusJSON) => {
        //       console.log("filtro de disponibilidad", data.result);

        //       this.panelLocationsService.setLoading(false);
        //       this.$Items = data.result;
        //       this.$ItemsGet = this.$Items;
        //       this.ApplyAvailabilityFilter = true;
        //       this.categories.find( cat =>cat.category.id == category.id ).total = data.result.length
        //     },
        //     (error) => {
        //       //Error callback
        //       this.notificationsToastService.showErrorSystem();
        //       this.panelLocationsService.setLoading(false);
        //       return false;
        //     }
        //   );
      }

    }
  }

  getFilterTab(tipoTab: string, identificadorFinder: string) {
    this.subscription_GetListFiltered = this.panelLocationsService
        .getListFilterTab(this.filtersSelected, tipoTab, identificadorFinder, this.selectedCategoryItem?.id || 0)
        .subscribe(
          (data: EstatusJSON) => {
            console.log("filtro ", data.result);
            this.$Items = data.result;
            this.$Items.forEach(item => {
              item.panelIcon = item.icon;
            });
            this.$ItemsGet = this.$Items;
            this.ApplyFilter = true;
            this.panelLocationsService.setLoading(false);
          },
          (error) => {
            //Error callback
            // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
            this.panelLocationsService.setLoading(false);
            return false;
          }
        );
  }

  getLocationFilter(selectedCategorY: number = null) {
    //!this.availabilityFilter
    if (true) {
      console.log("GetLocationsListFiltered");
      if (!this.ApplyFilter) {
        this.itemsFilterRespaldo = this.$Items;
        this.itemsGetFilterRespaldo = this.$ItemsGet;
      }
      this.subscription_GetListFiltered = this.panelLocationsService
        .getListFilter(this.filtersSelected)
        .subscribe(
          (data: EstatusJSON) => {
            this.panelLocationsService.setLoading(false);
            this.$Items = this.itemsFilterRespaldo.filter((item) =>
              data.result.some(
                (argItem) => argItem.identifier === item.identifier
              )
            );
            this.$ItemsGet = this.$Items;
            this.ApplyFilter = true;
          },
          (error) => {
            //Error callback
            // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
            this.panelLocationsService.setLoading(false);
            return false;
          }
        );
    }else{
      // this.subscription_GetListFiltered = this.panelLocationsService
      //     .GetListAvailabilityFilterByLocationCategory(
      //       this.availabilityFiltersSelected,
      //       this.availabilityInitialDate.toISOString(),
      //       this.availabilityFinalDate.toISOString(),
      //       [selectedCategorY]
      //     )
      //     .subscribe(
      //       (data: EstatusJSON) => {
      //         console.log("filtro de disponibilidad", data.result);

      //         this.panelLocationsService.setLoading(false);
      //         this.$Items = data.result;
      //         this.$ItemsGet = this.$Items;
      //         this.categories.find( cat =>cat.category.id == selectedCategorY ).total = data.result.length;
      //       },
      //       (error) => {
      //         //Error callback
      //         this.notificationsToastService.showErrorSystem();
      //         this.panelLocationsService.setLoading(false);
      //         return false;
      //       }
      //     );
    }

  }

  setLocationList(data: any, page : number) {
    if(this.isLocationListEnd){
      return;
    }

    const locationList = data.result.listaLocaciones as LocationDTO[];

    // si ya no hay datos, se termina la busqueda
    if (locationList.length == 0) {
      this.isLocationListEnd = true;
      var empty = new Array<LocationDTO>();
      this.setLocationPage(empty, page);
      return;
    }

    // si hay menos de 20 elementos, se asignan los que hay y termina la busqueda
    if (locationList.length < 20) {
      this.isLocationListEnd = true;
      this.setLocationPage(locationList, page);
      return;
    }

    this.setLocationPage(locationList, page);
  }

  setLocationPage(result: LocationDTO[], page: number) {
    result.forEach(item => {
      item.panelIcon = item.icon;

      // item.flagTypes = this.dummyFlagTypes;

      item.statusFlags = item.statusFlags || [];
      item.statusFlags.push(...this.getStatusFlagsByFlagTypes(item.flagTypes));
    });
    if(page == 1){
      this.$Items = result;
      this.$ItemsGet = this.$Items;
    }

    if(page != 1){
      this.$Items = this.$Items.concat(result);
      this.$ItemsGet = this.$Items;
    }

    this.panelLocationsService.setLoading(false);
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  onCardClicked(id: any) {
    var elemento: LocationDTO;
    if (this.isGlobalFilterActive) {
      this.$itemsFilterGlobal.forEach((element) => {
        if (element.location == id) {
          elemento = element.location;
        }
      });
    } else {
      this.$Items.forEach((element) => {
        if (element == id) {
          elemento = element;
        }
      });
    }

    //Add Client to SignalHub
    this.signalUser.Identifier = elemento.identifier;
    this.SubscribeSignalUser(this.signalUser);

    //Emit event
    this.signalIdentifier = elemento.identifier;
    var location = { identifier: elemento.identifier, idLocationCategory: elemento.idLocationCategory };
    this.onCardClickedEmitter.emit(location);
    console.log("Emitter Enfoque Pin, " + elemento);
    //Reset filter
    console.log("reset filter...");
    if (!this.isGlobalFilterActive) {
      this.$Items = this.$ItemsGet.slice();
    }
  }

  SubscribeSignalUser(SignalUser: SignalUser) {
    //Subscribe to SignalClient
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.fullScreen = false;
    this.signalUserService.SubscribeIdentifierSignalUserService(SignalUser);
    this.signalRService.ActivateListenerUpdateLocationActive();
  }

  UnsubscribeSignalUser(SignalUser: SignalUser) {
    //Subscribe to SignalClient
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.signalUserService.UnsubscribeSignalUserIdentifierService(this.signalIdentifier);
    this.signalIdentifier = "";
  }

  CancelButton() {
    console.log("Regresando home");
  }

  getFilters() {
    this.subscription_GetFilters = this.filterMapService
      .getFiltersByModule(this.moduleSearch)
      .subscribe((data: EstatusJSON) => {
        const filters = data.result;
        filters.forEach((element) => {
          element.module = this.moduleSearch;
          this.subscription_GetValuesFilters = this.filterMapService
            .getValuesByFilterModule(element.key, this.moduleSearch)
            .subscribe((res) => {
              const filterValues = res.result;
              this.filters.push({
                key: element.key,
                values: filterValues,
              });
              this.filtersObject = {filters: this.filters, selected: this.filtersSelected};
              // this.AvailabilityFiltersObject = {filters: this.filters, selected: this.availabilityFiltersSelected, startDate: this.availabilityInitialDate, endDate: this.availabilityFinalDate, idLocationCategories: null};
            });
        });
        console.log("Filters", this.filters);
      });
  }

  filterResponse(res: any): void {
      if (res.search) {
        console.log("Filtro de búsqueda activado", res);
        this.panelLocationsService.setLoading(true);
        this.filtersSelected = res.filtersSelected;
        if (this.filtersSelected.length > 0) {
          this.GetGPSTotals();
          this.GetCategoriesTotals(true);
          this.getLocations();
        } else {
          this.unsubscribeTabs();
          this.filtersSelected = [];
          this.filtersObject = {filters: this.filters, selected: this.filtersSelected};
          this.ApplyFilter = false;
          this.isLocationListEnd = false;
          this.GetGPSTotals();
          this.GetCategoriesTotals(false);
          this.getLocations();
          this.panelLocationsService.setLoading(false);
        }
        const filters = { normalFilter: this.filtersObject, availabilityFilter: null };
        this.onCardFilterEmitter.emit(filters);
      }
  }

  // availabilityFilterResponse(res: any): void {
  //   console.log("disponibilidad respuesta", res);

  //     if (res.search) {
  //       this.panelLocationsService.setLoading(true);
  //       if (res.initialDate != null && res.finalDate  != null) {
  //         console.log("AVA res", res);

  //         this.availabilityFiltersSelected = res.filtersSelected;
  //         this.availabilityInitialDate = res.initialDate;
  //         this.availabilityFinalDate = res.finalDate;
  //         this.availabilityCateoriesSelected = res.selectedCategories;
  //         this.isVisibleGPSTabs = res.isVisibleGPSTabs;
  //         this.availabilityFilter = true;
  //         this.AvailabilityFiltersObject = {filters: this.filters, selected: this.filtersSelected, startDate: this.availabilityInitialDate, endDate: this.availabilityFinalDate, idLocationCategories: this.availabilityCateoriesSelected};

  //         this.categories.forEach(cat => {
  //           cat.isVisible = true;
  //           if (!this.availabilityCateoriesSelected.includes(cat.category.id)) {
  //             cat.isVisible = false;
  //           }
  //         });
  //         if (this.isVisibleGPSTabs) {
  //           this.getLocationFilter();
  //         }else{
  //           var visibleCategoriesArray : number[] = [];
  //           if (this.selectedCategoryItem == null) {
  //             visibleCategoriesArray = this.categories.filter(cat => cat.isVisible).map(cat => cat.category.id);
  //           }else{
  //             visibleCategoriesArray.push(this.selectedCategoryItem.id);
  //           }
  //           this.panelInternalLayerService.DeactivateAllLayers();
  //           this.panelInternalLayerService.onToggleLayerActivos(false);
  //           this.panelInternalLayerService.onToggleLayerFiltros(true);
  //           this.getLocationFilter(visibleCategoriesArray[0]);
  //         }

  //         this.ApplyAvailabilityFilter = true;
  //       }else{
  //         this.unsubscribeTabs();
  //         this.availabilityFiltersSelected = [];
  //         this.availabilityInitialDate = null;
  //         this.availabilityFinalDate = null;
  //         this.AvailabilityFiltersObject = {filters: this.filters, selected: this.filtersSelected, startDate: this.availabilityInitialDate, endDate: this.availabilityFinalDate, idLocationCategories: null};
  //         this.ApplyAvailabilityFilter = false;
  //         this.availabilityFilter = false;

  //         this.isVisibleGPSTabs = true;
  //         this.availabilityCateoriesSelected = null;
  //         this.categories.forEach(cat => {
  //           cat.isVisible = true;
  //         });
  //         this.mapHelperService.UpdateLayerGeoJson(
  //           "filterPointsSource",
  //           this.mapHelperService.Empty_GeoJson
  //         );
  //         this.panelInternalLayerService.onToggleLayerActivos(true);
  //           this.panelInternalLayerService.onToggleLayerFiltros(false);
  //         this.getLocations();
  //         this.panelLocationsService.setLoading(false);
  //       }

  //       const filters = { normalFilter: null, availabilityFilter: this.AvailabilityFiltersObject };
  //       this.onCardFilterEmitter.emit(filters);
  //     }
  // }

  onGlobalFilterButton(event){
    if (event > 0) {
      this.onGlobalFilter(event);
    }
    else{
      return;
    }
  }

  onGlobalFilter(event) {
    if (!this.mobileQuery.matches) {
      this.fullScreen = true;
    }
    this.$itemsFilterGlobal = [];
    if (event.length > 0) {
      this.isLoading = true;
      this.isGlobalFilterActive = true;

      // Cancelar las suscripciones anteriores
      // this.subscriptionsFilter.forEach((subscription) =>
      //   subscription.unsubscribe()
      // );
      // this.subscriptionsFilter = [];

      this.unsubscribeGlobalFilter();
      this.unsubscribeFocusPin();
      this.unsubscribeTabs();
      // Agregar busquedas como subscripciones para después detener
      this.subscription_GetAllLocationsFilteredList = this.panelLocationsService.FindAllByIdentifier(event).subscribe((data: any) => {
        if (data.isSuccess == false) {
          // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
          this.isLoading = false;
          return;
        }
        this.$itemsFilterGlobal = data.result;
        this.$itemsFilterGlobal.forEach((item) => {
          item.location.panelIcon = item.location.icon;
          
          // item.location.flagTypes = this.dummyFlagTypes;

          item.location.statusFlags = item.location.statusFlags || [];
          item.location.statusFlags.push(...this.getStatusFlagsByFlagTypes(item.location.flagTypes));
        });
        this.vinsFilterGlobal = this.$itemsFilterGlobal.map(
          (item) => item.location
        );
        this.isLoading = false;
      });
    } else {
      this.isGlobalFilterActive = false;
      this.isLoading = false;
      this.selectTab({ tab: { textLabel: 1 } });
    }
  }

  GetCategories(){
    try{
    const categories = JSON.parse(localStorage.getItem("listaCategorias")) as LocationCategoryDTO[];
    this.isVisibleGPSTabs = categories.some(category => category.itWorksAsGPS);

    categories.filter(cat => cat.itWorksAsGPS == false && cat.itWorksAsVirtualLocation == false).forEach(cat=> {
      var total = 0;
      if (cat.total != null) {
        total = cat.total;
      }
      this.categories.push({ category: cat, total: total, isVisible: true });
    });
    this.categories.forEach(cat => {
      cat.category.panelIcon = cat.category.icon;
    });

    if (!this.isVisibleGPSTabs && this.categories.length > 0) {
      this.selectedTabIndex = 4;
      this.selectTab({ tab: { textLabel: this.selectedTabIndex } });
    }
  }catch(error){
    console.log(error);
  }
  }

  GetGPSTotals(){
    try{
      this.subscription_GetTotalActualizado = this.panelLocationsService.GetCountListActualizados(this.filtersObject.selected).subscribe( (data: EstatusJSON) => {
        if (data.isSuccess == true) {
            this.totalActualizados = data.result.toString();
          }
        },
        (error) => {
          // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        }
      );

      this.subscription_GetTotalDesactualizado = this.panelLocationsService.GetCountListDesactualizados(this.filtersObject.selected).subscribe( (data: EstatusJSON) => {
          if (data.isSuccess == true) {
            this.totalDesactualizados = data.result.toString();
          }
        },
        (error) => {
          // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        }
      );

      this.subscription_GetTotalSinReporte = this.panelLocationsService.GetCountListSinReporte(this.filtersObject.selected).subscribe((data: EstatusJSON) => {
          if (data.isSuccess == true) {
            this.totalSinReporte = data.result.toString();
          }
        },
        (error) => {
          // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        }
      );
    }catch(error){
      console.log(error);
    }
  }

  async GetCategoriesTotals(hasFilter: boolean){
    try{
      if (hasFilter) {
        for (let category of this.categories){
          const resp = await firstValueFrom(this.panelLocationsService.GetCountByIdLocationCategory(category.category.id, this.filtersObject.selected));
          if(resp.isSuccess)
            category.total = resp.result;
        }
      }else{
        const categories = JSON.parse(localStorage.getItem("listaCategorias")) as LocationCategoryDTO[];
        this.categories.forEach(category => {
          var originalCategory = categories.find( originalCat => originalCat.id == category.category.id);
          category.total = originalCategory ? originalCategory.total : 0 ;
        });
      }
      
    }catch(error){
      console.log(error);
    }
  }


  SetSystemLayersOn(category: LocationCategoryDTO){
    var systemLayer = new LayerDTO();
    systemLayer.name = category.shortName;
    systemLayer.categoryId = category.id;
    console.log("capas panel", this.panelInternalLayerService.capas);
    if (this.panelInternalLayerService.capas.length > 0) {
      this.panelInternalLayerService.ActivateLayer(systemLayer);
    }else{
      setTimeout(() => {
        this.panelInternalLayerService.ActivateLayer(systemLayer);
      }, 4000);
    }
  }

  ClosePanel(){
    this.fullScreen = false;
    this.panelLocationsService.setVisibilityPanel(false);
    this.panelLocationsService.setSearchVisibility(true);
  }

  onScroll(event: any): void {
    if(this.isLocationListEnd || this.isLoading){
      return;
    }

    if (this.filtersSelected.length > 0){
      return;
    }
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= (element.clientHeight + 10)) {
      this.loadMoreLocations();
    }
  }

  loadMoreLocations(): void {
    this.panelLocationsService.setLoading(true);
    // se obtiene la página de tal forma que si hay números residuales, se vuelva a pedir desde la página con los residuos incluidos, para evitar lapsos
    var page = 0;
    var length = this.$Items.length;
    var residue = length % 20;
    if (residue != 0) {
      page = Math.floor(length / 20);
      // si el numero de residuo es mayor a 0 pero el total menor a 10, dará 0, se suma 1 a la página para que se pida desde la primera
      if(page < 1){
        page = 1;
      }
    }else{
      page = (length / 20) + 1;
    }
    console.log('page', length, residue, page);
    this.getLocations(page);
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess("Texto copiado al portapapeles", text);
  }

  resetGlobalFilterValue(): void {
    this.globalFinder = '';
    this.onGlobalFilter(this.globalFinder);
  }

  getStatusFlagsByFlagTypes(flagTypes: number[]) : StatusFlag[] { 
    var statusFlags = [];
    if (flagTypes == null || flagTypes.length < 1) {
      return statusFlags;
    }
    flagTypes.forEach(flagType => {
      var statusKey = Object.keys(EnumAlarmCategory).find(key => EnumAlarmCategory[key] === flagType);
      console.log("statusKey", statusKey, EnumAlarmCategoriesValues[statusKey], EnumAlarmCategoriesColors[statusKey]);
      
      if (statusKey) {
        var statusFlag = { flagName: EnumAlarmCategoriesValues[statusKey], priorityHex: EnumAlarmCategoriesColors[statusKey] } as StatusFlag;
        statusFlags.push(statusFlag);
      }else{
        return null;
      }
    });
    return statusFlags;
  }
}
